import { useCallback } from 'react';
import useAgentData from '~/client/hooks/useAgentData';
import useSite from '~/client/hooks/useSite';
import { useAddToRecentMutation } from './AddToRecentMutation.generated';

const useAddToRecent = () => {
  const { site } = useSite();
  const { deviceType: type } = useAgentData();
  const [addToRecentMutation] = useAddToRecentMutation();

  const addToRecent = useCallback(
    async (gameId: string) =>
      addToRecentMutation({
        variables: {
          gameId,
          myFavouritesFilter: { site, type },
          myRecentsFilter: { site, type },
        },
      }),
    [addToRecentMutation, site, type],
  );

  return addToRecent;
};

export default useAddToRecent;
